import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './EnrollmentForm.css';

const Enrollment = () => {
  const [submitted, setSubmitted] = useState(false);
  const formRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formRef.current) {
      formRef.current.submit();
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className="enrollment">
        <div className="enrollment__container">
          <div className="form-success">
            <h2>Thank You for Your Enrollment!</h2>
            <p>Your information has been submitted successfully. We'll get in touch with you soon.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="enrollment">
      <div className="enrollment__container">
        <h1 className="enrollment__title">Course Enrollment</h1>
        
        <div className="enrollment__content">
          <div className="enrollment__info">
            <div className="enrollment__info-card">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="enrollment__icon" />
              <h3 className="enrollment__info-title">Our Office</h3>
              <p className="enrollment__info-text">Asif Nagar, Karimnagar, Telangana, India </p>
            </div>
            
            <div className="enrollment__info-card">
              <FontAwesomeIcon icon={faPhone} className="enrollment__icon" />
              <h3 className="enrollment__info-title">Phone</h3>
              <p className="enrollment__info-text">
                <a href="tel:+916309012237" className="enrollment__link">
                  +91 6309012237
                </a>
              </p>
              {/* <p className="enrollment__info-text">
                <a href="tel:+919441222237" className="enrollment__link">
                  +91 9441222237
                </a>
              </p> */}
              <div className="enrollment__whatsapp-buttons">
                <a
                  href="https://wa.me/916309012237?text=Hi%20CodeXLNC,%20I%20have%20a%20question%20about%20your%20courses"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="enrollment__whatsapp-btn"
                >
                  WhatsApp 6309012237
                </a>
                {/* <a
                  href="https://wa.me/919441222237?text=Hi%20CodeXLNC,%20I%20have%20a%20question%20about%20your%20courses"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="enrollment__whatsapp-btn"
                >
                  WhatsApp 9441222237
                </a> */}
              </div>
            </div>
            
            <div className="enrollment__info-card">
              <FontAwesomeIcon icon={faEnvelope} className="enrollment__icon" />
              <h3 className="enrollment__info-title">Email</h3>
              <p className="enrollment__info-text">
                <a href="mailto:info@codexlnc.com" className="enrollment__link">
                  info@codexlnc.com
                </a>
              </p>
              <p className="enrollment__info-text">
                <a href="mailto:support@codexlnc.com" className="enrollment__link">
                  support@codexlnc.com
                </a>
              </p>
              <p className="enrollment__info-text">
                <a href="mailto:codexlnc.cxc@gmail.com" className="enrollment__link">
                  codexlnc.cxc@gmail.com
                </a>
              </p>
            </div>
          </div>
          
          <div className="enrollment__form-container">
            <h2 className="enrollment__form-title">Enroll Now</h2>
            <form 
              ref={formRef}
              action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DgK000002SOUb"
              method="POST"
              className="enrollment__form"
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="oid" value="00DgK000002SOUb" />
              <input type="hidden" name="retURL" value="http://www.codexlnc.com" />
              
              <div className="enrollment__form-group">
                <label htmlFor="salutation">Salutation</label>
                <select id="salutation" name="salutation" className="enrollment__select" required>
                  <option value="">--None--</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Ms.">Ms.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Dr.">Dr.</option>
                  <option value="Prof.">Prof.</option>
                  <option value="Mx.">Mx.</option>
                </select>
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="first_name">First Name</label>
                <input
                  id="first_name"
                  maxLength="40"
                  name="first_name"
                  type="text"
                  className="enrollment__input"
                  required
                />
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="last_name">Last Name</label>
                <input
                  id="last_name"
                  maxLength="80"
                  name="last_name"
                  type="text"
                  className="enrollment__input"
                  required
                />
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  maxLength="80"
                  name="email"
                  type="email"
                  className="enrollment__input"
                  required
                />
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  id="phone"
                  maxLength="40"
                  name="phone"
                  type="tel"
                  className="enrollment__input"
                  required
                />
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="company">Company / College</label>
                <input
                  id="company"
                  maxLength="40"
                  name="company"
                  type="text"
                  className="enrollment__input"
                />
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="country_code">Country</label>
                <select id="country_code" name="country_code" className="enrollment__select" required>
                  <option value="">--None--</option>
                  <option value="IN">India</option>
                  <option value="US">United States</option>
                  <option value="GB">United Kingdom</option>
                  {/* Add more countries as needed */}
                </select>
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="interested_course">Interested Course</label>
                <select
                  id="00NgK000013x4QL"
                  multiple
                  name="00NgK000013x4QL"
                  className="enrollment__select enrollment__select-multiple"
                  title="Interested Course"
                  required
                >
                  <option value="Salesforce Platform Developer">Salesforce Platform Developer</option>
                  <option value="Salesforce LWC Developer">Salesforce LWC Developer</option>
                  <option value="Salesforce Administrator">Salesforce Administrator</option>
                  <option value="Salesforce Business Analyst">Salesforce Business Analyst</option>
                  <option value="Salesforce Sales Consultant">Salesforce Sales Consultant</option>
                  <option value="Salesforce Service Consultant">Salesforce Service Consultant</option>
                </select>
                <small className="enrollment__hint">(Hold Ctrl/Cmd to select multiple courses)</small>
              </div>
              
              <div className="enrollment__form-group">
                <label htmlFor="expected_joining">Expected Joining Date</label>
                <input
                  id="00NgK00000ysX7j"
                  name="00NgK00000ysX7j"
                  type="date"
                  className="enrollment__input"
                  required
                />
              </div>
              
              <button type="submit" className="enrollment__submit-btn">
                Submit Enrollment
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Enrollment;